import React from 'react';
import { type PreviewEyeProps } from './preview_eye';

type Props = {
  isHidden?: boolean,
  preview: boolean,
  previewEye: PreviewEyeProps,
  text: string,
  value: string | number,
}

export default function BasicCard({
  isHidden, preview, previewEye, text, value,
}: Props) {
  const textClasses = [
    'ds-client-report-text',
    'd-flex',
    'align-items-center',
    'justify-content-center',
    'flex-grow',
    isHidden ? 'ds-client-report-text--hidden' : '',
  ].join(' ');

  return (
    <div className="ds-client-report-card d-flex">
      <div className="ds-client-report-value align-items-center justify-content-center d-flex py-3 px-4">
        <div>{value}</div>
      </div>
      <div
        className={textClasses}
        style={{ marginRight: '-30px' }}
      >
        {text}
      </div>
      { !preview && (
        <div className="align-content-top mt-1" style={{ marginRight: '15px' }}>{previewEye}</div>
      )}
    </div>
  );
}
